import { Grid } from "@mui/material";
import { observer } from "mobx-react";
import React from "react";
import { useStore } from "utils/useStore";
import { LLMClassifierBuilderStore } from "components/Classifiers/LLMClassifiers/Stores/LLMClassifierBuilderStore";
import { AgreementTestingResults } from "../../Components/ModelTester/Agreement/AgreementTestingResults";
import AcxEmptyState from "components/UI/AcxEmptyStateIndicator/AcxEmptyState";
import { OnConversationsTestingResults } from "../../Components/ModelTester/OnConversations/OnConversationsTestingResults";
import { TestProgressPanel } from "../../Components/ModelTester/TestProgressPanel";

export const LLMClassifierTesting = observer(() => {
    const store = useStore(LLMClassifierBuilderStore);
    const isResultsLoading = store.getTaskLoading(LLMClassifierBuilderStore.Tasks.TestLLMClassifier);
    const agreementResults = store.testAgreementResponse;
    const onConversationsResults = store.testOnConversationsResponse;
    const hasResults = (agreementResults?.processedCount ?? onConversationsResults?.processedCount ?? 0) > 0;

    return (
        <Grid container direction="column" flexWrap="nowrap" width="100%">
            {store.testProgress && (
                <TestProgressPanel
                    progress={store.testProgress}
                    isRunning={isResultsLoading}
                    hasResults={hasResults}
                    onCancel={() => store.cancelTestLLMClassifier()}
                />
            )}
            {agreementResults && agreementResults.processedCount > 0 && (
                <AgreementTestingResults data={agreementResults} />
            )}
            {onConversationsResults && onConversationsResults.processedCount > 0 && (
                <OnConversationsTestingResults data={onConversationsResults} />
            )}
            {!isResultsLoading && !hasResults && (
                <AcxEmptyState
                    size="small"
                    variant="empty"
                    overrideTitle="No test results to show"
                    overrideSubTitle=""
                />
            )}
        </Grid>
    );
});
